import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-6">
      <p className="text-sm uppercase tracking-widest text-muted-foreground">
        404
      </p>
      <h1 className="mt-4 text-4xl font-semibold">Seite nicht gefunden</h1>
      <p className="mt-2 text-muted-foreground max-w-sm">
        Diese Seite existiert (noch) nicht. Vielleicht ist sie auch nur auf der
        10-Tage-Warteliste.
      </p>
      <Link
        to="/"
        className="mt-8 px-5 py-2.5 rounded-full bg-accent text-accent-foreground hover:opacity-90 transition"
      >
        Zurück zur Startseite
      </Link>
    </div>
  );
}
